import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M64 368v80h80l235.73-235.73-80-80L64 368zm377.6-217.6c8.53-8.53 8.53-21.34 0-29.87L391.47 70.4c-8.53-8.53-21.34-8.53-29.87 0l-39.47 39.47 80 80 39.47-39.47z" /></svg>;